/**
 * SS PDP what's inside — <ss-pdp-whats-inside>
 * Thickness tabs show the matching panel; each panel has an accordion of
 * layers (one open at a time) whose open row may swap the diagram image
 * (data-imgsrc). Follows the product variant: on `variant:change` /
 * pub-sub variantChange the tab matching the variant's height option is
 * selected. No text or URLs here.
 */
(function () {
  'use strict';
  if (customElements.get('ss-pdp-whats-inside')) return;

  function ssPubSubEvents() {
    try { if (typeof PUB_SUB_EVENTS !== 'undefined') return PUB_SUB_EVENTS; } catch (e) { /* noop */ }
    return window.PUB_SUB_EVENTS || null;
  }

  class SsPdpWhatsInside extends HTMLElement {
    constructor() { super(); this._listeners = []; }

    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-ss-thickness]'));
      this.panels = Array.from(this.querySelectorAll('.wuc-thickness-content'));
      this.tabs.forEach(function (tab) {
        this.on(tab, 'click', function () { this.selectThickness(tab.dataset.thickness, true); }.bind(this));
        this.on(tab, 'keydown', function (event) {
          var i = this.tabs.indexOf(tab);
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            var next = this.tabs[(i + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length];
            next.focus(); this.selectThickness(next.dataset.thickness, true);
          }
        }.bind(this));
      }, this);
      this.on(this, 'click', function (event) {
        var toggle = event.target.closest('[data-ss-layer-toggle]');
        if (toggle && this.contains(toggle)) this.toggleLayer(toggle);
      }.bind(this));
      this.onVariant = this.onVariant.bind(this);
      this.on(document, 'variant:change', this.onVariant);
      var events = ssPubSubEvents();
      if (events && typeof subscribe === 'function') this.unsubscribe = subscribe(events.variantChange, this.onVariant);
      this.panels.forEach(function (panel) { this.applyOpenImage(panel); }, this);
    }

    disconnectedCallback() {
      this._listeners.forEach(function (l) { l[0].removeEventListener(l[1], l[2]); });
      this._listeners = [];
      if (typeof this.unsubscribe === 'function') this.unsubscribe();
    }

    on(el, type, fn) { el.addEventListener(type, fn); this._listeners.push([el, type, fn]); }

    selectThickness(value, byUser) {
      if (!value) return;
      var found = false;
      this.panels.forEach(function (panel) {
        var match = panel.dataset.thickness === value;
        panel.hidden = !match;
        if (match) found = true;
      });
      if (!found) return;
      this.tabs.forEach(function (tab) {
        var active = tab.dataset.thickness === value;
        tab.classList.toggle('wuc-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      if (byUser) this.dispatchEvent(new CustomEvent('ss-pdp:thickness', { bubbles: true, detail: { thickness: value } }));
    }

    toggleLayer(toggle) {
      var li = toggle.closest('.wuc-feature');
      var panel = li && li.closest('.wuc-thickness-content');
      if (!li || !panel) return;
      var willOpen = !li.classList.contains('wuc-feature-open');
      panel.querySelectorAll('.wuc-feature').forEach(function (row) {
        var open = willOpen && row === li;
        row.classList.toggle('wuc-feature-open', open);
        var button = row.querySelector('[data-ss-layer-toggle]');
        var content = row.querySelector('.wuc-feature-content');
        var icon = row.querySelector('.wuc-toggle-btn');
        if (button) button.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (content) content.hidden = !open;
        if (icon) { icon.classList.toggle('wuc-minus', open); icon.classList.toggle('wuc-plus', !open); }
      });
      this.applyOpenImage(panel);
    }

    /* Swap the diagram to the open layer's image (or back to the default) */
    applyOpenImage(panel) {
      var img = panel.querySelector('.wuc-image-change');
      if (!img || img.tagName !== 'IMG') return;
      var open = panel.querySelector('.wuc-feature-open [data-ss-layer-toggle]');
      var src = (open && open.dataset.imgsrc) || img.dataset.defaultSrc || img.getAttribute('src');
      var alt = (open && open.dataset.imgalt) || img.dataset.defaultAlt || img.getAttribute('alt');
      if (!img.dataset.defaultAlt) img.dataset.defaultAlt = img.getAttribute('alt') || '';
      if (img.getAttribute('src') === src) return;
      img.classList.add('is-swapping');
      var next = new Image();
      next.onload = function () {
        img.removeAttribute('srcset');
        img.src = src;
        img.alt = alt || '';
        img.classList.remove('is-swapping');
      };
      next.onerror = function () { img.classList.remove('is-swapping'); };
      next.src = src;
    }

    onVariant(event) {
      var variant = (event && event.detail && event.detail.variant) || (event && event.data && event.data.variant) || null;
      if (!variant || !Array.isArray(variant.options)) return;
      var pos = parseInt(this.dataset.heightPosition, 10) || 2;
      var value = variant.options[pos - 1];
      if (value) this.selectThickness(String(value), false);
    }
  }

  customElements.define('ss-pdp-whats-inside', SsPdpWhatsInside);
})();
